module.exports = __webpack_public_path__ + "static/media/symbol_text_and_icon.fragment.c4786ad2.glsl";